import { IconCheck } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import Select, { StylesConfig } from "react-select";

interface RestrictionFilterProps {
    setRestrictionFilter: (restrictionFilter: string[]) => void;
    menuZIndex?: number;
}

const RestrictionFilter: React.FC<RestrictionFilterProps> = ({ setRestrictionFilter, menuZIndex }) => {
    const defaultRestriction = { value: "rate", label: "RATE" };
    const allRestrictions = { value: "1", label: "All Restrictions" };
    const restrictionOptions = [
        allRestrictions,
        { value: "cta", label: "CTA" },
        { value: "ctd", label: "CTD" },
        defaultRestriction,
        { value: "ss", label: "STOP" },
        { value: "mxs", label: "MAX" },
        { value: "msa", label: "MIN" },
        { value: "mst", label: "MIN-T" },
    ];
    const [restrictions, _setRestrictions] = useState<OptionType[]>(restrictionOptions);
    const [selectedRestrictions, setSelectedRestrictions] = useState<OptionType[]>([defaultRestriction]);

    // useEffect(() => {
    //     if (selectedRestrictions.length === 1 && selectedRestrictions[0].value === defaultRestriction.value) {
    //         setRestrictionFilter(restrictionOptions.filter((restriction) => restriction.value !== defaultRestriction.value).map((restriction) => restriction.value));
    //     }
    // }, []);

    useEffect(() => {
        if (selectedRestrictions.length === 1 && selectedRestrictions[0].value === defaultRestriction.value) {
            setRestrictionFilter([defaultRestriction.value]);
        }
    }, []);

    return (
        <RestrictionSelect
            defaultRestriction={allRestrictions}
            restrictions={restrictions}
            selectedRestrictions={selectedRestrictions}
            setSelectedRestrictions={setSelectedRestrictions}
            setRestrictionFilter={setRestrictionFilter}
            menuZIndex={menuZIndex}
        />
    );
};

export default RestrictionFilter;

type OptionType = {
    value: string;
    label: string;
};

interface RestrictionSelectProps {
    defaultRestriction: OptionType;
    restrictions: OptionType[];
    selectedRestrictions: OptionType[];
    setSelectedRestrictions: (restrictions: OptionType[]) => void;
    setRestrictionFilter?: (restrictionFilter: string[]) => void;
    menuZIndex?: number;
}

const CustomOption = (props: any) => {
    const { data, isSelected, innerRef, innerProps } = props;

    return (
        <div ref={innerRef} {...innerProps} className="d-flex justify-content-between align-items-center p-2">
            <span>{data.label}</span>
            {isSelected && <IconCheck size={16} />}
        </div>
    );
};

const RestrictionSelect: React.FC<RestrictionSelectProps> = ({
    defaultRestriction,
    restrictions,
    selectedRestrictions,
    setSelectedRestrictions,
    setRestrictionFilter,
    menuZIndex = 1000,
}) => {
    const customStyles: StylesConfig<OptionType, true> = {
        menuPortal: (base) => ({
            ...base,
            zIndex: menuZIndex, // Pastikan z-index cukup tinggi
        }),
    };

    const handleChange = (selected: OptionType[]) => {
        if (selected.length === 1 && selected[0].value === defaultRestriction.value) {
            setSelectedRestrictions([defaultRestriction]);
            setRestrictionFilter?.(restrictions.filter((restriction) => restriction.value !== defaultRestriction.value).map((restriction) => restriction.value));
        } else {
            setSelectedRestrictions(selected.filter((restriction) => restriction.value !== defaultRestriction.value));
            setRestrictionFilter?.(selected.map((restriction) => restriction.value));
        }
    };

    return (
        <Select
            value={selectedRestrictions}
            options={restrictions}
            className="p-0"
            styles={{
                ...customStyles,
                singleValue: (base) => ({
                    ...base,
                    fontWeight: "bold",
                }),
            }}
            menuPortalTarget={document.body}
            menuPosition="absolute"
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            onChange={(selected) => handleChange(selected as OptionType[])}
            components={{
                Option: CustomOption,
                MultiValue: () => null,
                ValueContainer: ({ getValue }) => {
                    const selected = getValue();
                    return (
                        <div className="p-2">
                            {selected.length === 1 && selected[0].value === defaultRestriction.value
                                ? defaultRestriction.label
                                : `${selected.length} Restriction Selected`}
                        </div>
                    );
                },
            }}
        />
    );
};